/* eslint-disable */

import {
  Autocomplete,
  FormControl,
  FormLabel,
  Typography,
  Grid,
  Paper,
  TextField,
  Button,
  Box,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import { toast } from 'react-toastify';
import axios from 'axios';

import { useResponsiveStyles } from '../../utils/responsiveStyles';
import Key from '../../clientVariables.json';

const EditCustomer = ({ editCustomerData, cancelHandler }) => {
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    role: '',
    contactNumber: '',
    country: '',
    state: '',
    city: '',
    zipcode: '',
    companyName: '',
    companyUrl: '',
    description: '',
    category: '',
    address: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);
  const [categories, setCategories] = useState([]);
  const styles = useResponsiveStyles();
  const [customerDetails, setCustomerDetails] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  const getstatesObject = (stateString) => {
    const statesObject = stateList?.find((state) => state?.id === stateString);
    return statesObject || '';
  };
  const getCitiesObject = (cityString) => {
    console.log('cityString', cityString);
    const citiesObject = cityList?.find((city) => city?.id == cityString);
    return citiesObject || '';
  };
  const getZipcodesObject = (zipcodeString) => {
    console.log('zipcodeString', zipcodeString);
    const zipcodeObject = zipcodes?.find((zip) => zip?.zipcode == zipcodeString);
    return zipcodeObject || '';
  };
  const getCatogeryObject = (catString) => {
    const catObject = categories?.find((cat) => cat?.id === catString);
    return catObject || '';
  };

  useEffect(() => {
    getCustomerDetails(editCustomerData?.userid);
    getStates();

    getCategories();
    console.log('editCustomerData', editCustomerData);
    console.log('customerDetails edit', customerDetails);
  }, []);

  useEffect(() => {
    if (customerDetails) {
      console.log("customer details 9898", customerDetails);
      setFormData((prevData) => ({
        ...prevData,
        fullname: customerDetails?.userDetails?.full_name,
        email: customerDetails?.userDetails?.username,
        role: customerDetails?.userDetails?.role,
        contactNumber: customerDetails?.companyDetails?.contactphone || '',
        //   country: customerDetails?.userDetails?.full_name,
        state: getstatesObject(customerDetails?.userDetails?.state),
        city: getCitiesObject(customerDetails?.userDetails?.city),
        zipcode: getZipcodesObject(customerDetails?.userDetails?.zipcode),
        companyName: customerDetails?.companyDetails?.name || customerDetails?.userDetails?.company_name,
        companyUrl: customerDetails?.companyDetails?.url,
        description: customerDetails?.companyDetails?.description,
        category: getCatogeryObject(customerDetails?.companyDetails?.category),
        address: customerDetails?.companyDetails?.address1,
      }));
    }
  }, [customerDetails]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      city: getCitiesObject(customerDetails?.userDetails?.city),
    }));
  }, [cityList]);
  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      zipcode: getZipcodesObject(customerDetails?.userDetails?.zipcode),
    }));
  }, [zipcodes]);

  useEffect(() => {
    if (formData.state && formData.state) {
      console.log('state id', formData.state);
      getCities(formData.state.id);
    }
  }, [formData.state]);

  useEffect(() => {
    if (formData.city && formData.city) {
      console.log('state id', formData.city);
      getZipCodes(formData.city.id);
    }
  }, [formData.city]);

  useEffect(() => {
    let errorKey = null;

    Object.entries(formErrors).forEach(([key, value]) => {
      // console.log(`${key}@ ${value}`);
      errorKey = key;
    });

    if (errorKey) {
      const errors = validateForm();
      setFormErrors(errors);
    }
  }, [formData]);

  //   const handleChange = (field, value) => {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [field]: value,
  //     }));

  //   };

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleChange = (field, value) => {
    console.log(value);
    if (field === 'contactNumber') {
      const cleanedValue = value.replace(/\D/g, ''); // Remove non-numeric characters
      const formattedValue = formatPhoneNumber(cleanedValue);
      setFormData((prevData) => ({
        ...prevData,
        [field]: formattedValue,
      }));

      const phoneNumberPattern = /^\(\d{3}\) \d{3}-\d{4}$/;
      if (!phoneNumberPattern.test(formattedValue)) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          contactNumber: 'Invalid phone number format. Expected format: (XXX) XXX-XXXX',
        }));
      } else {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          contactNumber: '',
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }
  };

  const onTextEditorchanged = (value) => {
    // console.log(value);
    setFormData((prevData) => ({
      ...prevData,
      description: value,
    }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    const errors = validateForm();
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      console.log('formData', formData);
      try {
        const response = await axios.put(`${Key.domain}/customer/${editCustomerData?.userid}`, {
          email: formData.email,
          comp_url: formData.companyUrl,
          full_name: formData.fullname,
          mobile: formData.contactNumber,
          countryid: 233,
          stateid: formData.state?.id,
          cityid: formData.city?.id,
          zipcode: formData.zipcode.zipcode,
          role: formData.role,
          comp_name: formData.companyName,
          category: formData.category?.id,
          description: formData.description,
          address: formData.address,
        });
        if (response.status === 200) {
          console.log('customer add ', response.data);
          // response.data.data.company_id
          // response.data.data.message
          // response.data.data.user_id
          toast.success("Customer Data Updated", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setSubmitLoading(false);
          cancelHandler();
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong try again!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        setSubmitLoading(false);
        cancelHandler();

      }
    } else {
      const firstErrorField = Object.keys(errors)[0];
      document.getElementById(firstErrorField)?.focus();
    }
  };
  const validateForm = () => {
    const errors = {};
    const phoneNumberPattern = /^\(\d{3}\) \d{3}-\d{4}$/;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.fullname?.trim()) {
      errors.fullname = 'Full Name is required';
    }

    if (!formData.email?.trim()) {
      errors.email = 'Email is required';
    } else if (!emailPattern.test(formData.email)) {
      errors.email = 'Invalid email format';
    }

    if (!formData.role?.trim()) {
      errors.role = 'Role is required';
    }

    if (!formData.contactNumber.match(phoneNumberPattern)) {
      errors.contactNumber = 'Invalid phone number format. Expected format: (XXX) XXX-XXXX';
    }

    if (!formData.state?.name?.trim()) {
      errors.state = 'State is required';
    }

    if (!formData.city?.cityName?.trim()) {
      errors.city = 'City is required';
    }

    return errors;
  };

  const getStates = () => {
    fetch(`${Key.domain}/common/get_states_by_countryid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        country_id: 233,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setStateList(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };

  const getCities = (id) => {
    fetch(`${Key.domain}/common/get_cities_by_stateid`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        state_id: id,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setCityList(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };

  const getZipCodes = (id) => {
    fetch(`${Key.domain_jnp}/commonAPIs/get_zipcodes_By_cityId`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        city_id: id,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setZipcodes(data.data);
      })
      .catch((error) => {
        console.error('Error fetching states:', error);
      });
  };
  const getCategories = () => {
    axios
      .get(`${Key.domain}/common/get_all_categories`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      })
      .then((resdata) => {
        console.log(resdata.data.data);
        setCategories(resdata.data.data);
      });
  };
  const formatPhoneNumber = (value) => {
    if (!value) return value;

    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return value;
  };

  const getCustomerDetails = async (id) => {
    try {
      const response = await axios.post(`${Key.domain}/customer/get_upgrade_packagedetails`, {
        customer_id: id,
      });
      if (response.status === 200) {
        console.log(response.data.data);
        setCustomerDetails(response.data.data);
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch package details', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <Grid container spacing={0} sx={{ bgcolor: '#F2F4FA' }}>
      <Grid item xs={1.5} />
      <Grid item xs={9}>
        <Paper sx={{ padding: '20px' }}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Full Name</FormLabel>
                <TextField
                  placeholder="Full Name"
                  size="small"
                  value={formData.fullname}
                  onChange={(e) => handleChange('fullname', e.target.value)}
                  error={formErrors.fullname}
                  helperText={formErrors.fullname}
                  id="fullname"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Email</FormLabel>
                <TextField
                  placeholder="Email"
                  size="small"
                  value={formData.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  error={!!formErrors.email}
                  helperText={formErrors.email}
                  id="email"
                  autoComplete="off"
                  disabled
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Role</FormLabel>
                <TextField
                  placeholder="Role"
                  size="small"
                  value={formData.role}
                  onChange={(e) => handleChange('role', e.target.value)}
                  error={formErrors.role}
                  helperText={formErrors.role}
                  id="role"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Contact Number</FormLabel>
                <TextField
                  placeholder="(XXX) XXX-XXXX"
                  size="small"
                  value={formData.contactNumber}
                  onChange={(e) => handleChange('contactNumber', e.target.value)}
                  error={Boolean(formErrors.contactNumber)}
                  helperText={formErrors.contactNumber}
                  id="contactNumber"
                  autoComplete="off"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">+1</InputAdornment>,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Category</FormLabel>
                <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={categories}
                  getOptionLabel={(option) => option.category_title}
                  value={formData.category !== '' ? formData.category : null}
                  onChange={(event, newValue) => handleChange('category', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="Category" />}
                  error={formErrors.category}
                  helperText={formErrors.category}
                  id="category"
                />
                {formErrors.category && (
                  <Typography color="error" variant="caption">
                    {formErrors.category}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Company Name</FormLabel>
                <TextField
                  placeholder="Company Name"
                  size="small"
                  value={formData.companyName}
                  onChange={(e) => handleChange('companyName', e.target.value)}
                  error={formErrors.companyName}
                  helperText={formErrors.companyName}
                  id="companyName"
                  autoComplete="off"
                  disabled={formData.companyName === '' || formData.companyName === null}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Company URL</FormLabel>
                <TextField
                  placeholder="Company URL"
                  size="small"
                  value={formData.companyUrl}
                  onChange={(e) => handleChange('companyUrl', e.target.value)}
                  error={formErrors.companyUrl}
                  helperText={formErrors.companyUrl}
                  id="companyUrl"
                  autoComplete="off"
                  disabled={formData.companyUrl === '' || formData.companyUrl === null}

                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Address</FormLabel>
                <TextField
                  placeholder="Address"
                  size="small"
                  value={formData.address}
                  onChange={(e) => handleChange('address', e.target.value)}
                  error={formErrors.address}
                  helperText={formErrors.address}
                  id="address"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>State</FormLabel>
                <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={stateList}
                  getOptionLabel={(option) => option.name}
                  value={formData.state !== '' ? formData.state : null}
                  onChange={(event, newValue) => handleChange('state', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="State" />}
                  error={formErrors.state}
                  helperText={formErrors.state}
                  id="state"
                  disabled={formData && formData.workType === 'remote'}
                />
                {formErrors.state && (
                  <Typography color="error" variant="caption">
                    {formErrors.state}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>City</FormLabel>
                <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={cityList}
                  getOptionLabel={(option) => option.cityName}
                  value={formData.city !== '' ? formData.city : null}
                  onChange={(event, newValue) => handleChange('city', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="City" />}
                  error={formErrors.city}
                  helperText={formErrors.city}
                  id="city"
                  disabled={formData && formData.workType === 'remote'}
                />
                {formErrors.city && (
                  <Typography color="error" variant="caption">
                    {formErrors.city}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="standard" fullWidth>
                <FormLabel>Zipcode</FormLabel>
                <Autocomplete
                  size="small"
                  disablePortal
                  fullWidth
                  options={zipcodes}
                  getOptionLabel={(option) => option.zipcode}
                  value={formData.zipcode !== '' ? formData.zipcode : null}
                  onChange={(event, newValue) => handleChange('zipcode', newValue)}
                  renderInput={(params) => <TextField {...params} placeholder="Zipcode" />}
                  error={formErrors.zipcode}
                  helperText={formErrors.zipcode}
                  id="zipcode"
                />
                {formErrors.zipcode && (
                  <Typography color="error" variant="caption">
                    {formErrors.zipcode}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="standard" fullWidth>
                <FormLabel required>Description</FormLabel>
                <ReactQuill
                  theme="snow"
                  onChange={(e) => {
                    onTextEditorchanged(e);
                  }}
                  name="description"
                  value={formData.description}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                  <Button variant="outlined" size="small" onClick={cancelHandler}>
                    Cancel
                  </Button>
                  <Button variant="contained" size="small" onClick={submitHandler} disabled={submitLoading}>
                  {submitLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Save Changes"
            )}
                    
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={1.5} />
    </Grid>
  );
};

export default EditCustomer;
